import { useTheme } from '@emotion/react';
import { IconChevronDownSmall, IconChevronUpSmall } from '@hubble/icons/web';
import { useState, useEffect, Fragment } from 'react';
import { useId } from 'react-id-generator';
import { Card } from '../Card/index.js';
import { CardCollapsibleHeader, CardCollapsibleHeading, CardCollapsibleButton, CardCollapsibleContent } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const COLLAPSIBLE_ID_PREFIX = 'card-expanded-content-';
const CardCollapsible = ({
  children,
  heading,
  isOpen = undefined,
  onClick,
  padding = 'md',
  subheading,
  variant,
  ...props
}) => {
  const {
    translate
  } = useTheme();
  const [isExpanded, setIsExpanded] = useState(typeof isOpen !== 'undefined' ? isOpen : false);
  const [collapsibleId] = useId(1, COLLAPSIBLE_ID_PREFIX);
  const handleExpandedClick = e => {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
      if (typeof isOpen === 'undefined') setIsExpanded(previous => !previous);
    } else setIsExpanded(previous => !previous);
  };
  useEffect(() => {
    setIsExpanded(isOpen);
  }, [isOpen]);
  return jsxs(Card, {
    isCollapsible: true,
    padding: padding,
    variant: variant,
    "data-expanded": isExpanded,
    ...props,
    children: [jsxs(CardCollapsibleHeader, {
      padding: padding,
      children: [jsxs(CardCollapsibleHeading, {
        isExpanded: isExpanded,
        padding: padding,
        children: [jsx("div", {
          children: heading
        }), subheading && jsx("div", {
          children: subheading
        })]
      }), jsx(CardCollapsibleButton, {
        "aria-controls": isExpanded ? collapsibleId : undefined,
        "aria-expanded": isExpanded,
        "aria-label": translate('CardCollapsible.toggle'),
        "data-testid": "card-collapsible",
        icon: jsxs(Fragment, {
          children: [jsx(IconChevronDownSmall, {
            "aria-hidden": true,
            className: "unselected",
            size: "sm"
          }), jsx(IconChevronUpSmall, {
            "aria-hidden": true,
            className: "selected",
            size: "sm"
          })]
        }),
        onClick: handleExpandedClick,
        display: "inline-flex"
      })]
    }), isExpanded && jsx(CardCollapsibleContent, {
      padding: padding,
      id: collapsibleId,
      children: children
    })]
  });
};

export { CardCollapsible };
